import _ from 'lodash'
import api from '../api/remark'
import * as mutationTypes from './mutation-types'
import { REMARK_ACTIONS } from '../../../constants'

const Remarks = {
  state() {
    return {
      remarks: {},
      titles: {},
    }
  },

  getters: {
    remarkById: (state) => (id) => {
      return state.remarks[id]
    },

    notes: (state) => {
      return _.keyBy(_.filter(state.remarks, { todo: false }), 'id')
    },

    allTodos: (state) => {
      const todos = Object.values(state.remarks)

      return todos.reduce((accumulator, todo) => {
        return { ...accumulator, [todo['id']]: todo }
      }, {})
    },

    todos: (state) => {
      const todos = Object.values(state.remarks).filter(
        (el) => el.todo && !el.assistantCheckId
      )

      return todos.reduce((accumulator, todo) => {
        return { ...accumulator, [todo['id']]: todo }
      }, {})
    },

    openTodos: (state) => {
      const todos = Object.values(state.remarks).filter(
        (el) => el.todo && !el.done && !el.assistantCheckId
      )

      return todos.reduce((accumulator, todo) => {
        return { ...accumulator, [todo['id']]: todo }
      }, {})
    },

    doneTodos: (state) => {
      const todos = Object.values(state.remarks).filter(
        (el) => el.todo && el.done && !el.assistantCheckId
      )

      return todos.reduce((accumulator, todo) => {
        return { ...accumulator, [todo['id']]: todo }
      }, {})
    },

    sfAssistantCheckTodos: (state) => {
      const assistantCheckTodos = Object.values(state.remarks).filter(
        (el) => el.todo && el.assistantCheckId
      )

      return assistantCheckTodos.reduce((accumulator, todo) => {
        return { ...accumulator, [todo['assistantCheckId']]: todo }
      }, {})
    },

    notesByContext:
      (state) =>
      ({ type, id }) => {
        return _.keyBy(
          _.filter(state.remarks, {
            todo: false,
            contextType: type,
            contextId: id,
          }),
          'id'
        )
      },

    todosByContext:
      (state) =>
      ({ type, id }) => {
        return _.keyBy(
          _.filter(state.remarks, {
            todo: true,
            contextType: type,
            contextId: id,
          }),
          'id'
        )
      },
  },

  mutations: {
    [mutationTypes.SET_REMARKS](state, remarks) {
      state.remarks = remarks
    },

    [mutationTypes.REMARK_CHANGED](state, payload) {
      const { remark, action } = payload

      if (
        action === REMARK_ACTIONS.CREATED ||
        action === REMARK_ACTIONS.EDITED
      ) {
        state.remarks[remark.id] = remark
      } else if (action === REMARK_ACTIONS.DESTROYED) {
        delete state.remarks[remark.id]
      }
    },

    [mutationTypes.SET_TODO_DONE](state, { todo, done, doneAt, doneByName }) {
      // TODO: Verify the need for this bad practise
      todo.done = done
      todo.doneAt = doneAt
      todo.doneByName = doneByName
    },

    [mutationTypes.SET_REMARK_FOLLOWER_IDS](state, { remark, followerIds }) {
      // TODO: Verify the need for this bad practise
      remark.followerIds = followerIds
    },

    [mutationTypes.SET_REMARK_STICKY](state, { remark, sticky }) {
      remark.sticky = sticky
    },
  },

  actions: {
    async toggleTodoDone({ commit, getters, dispatch }, todoId) {
      const response = await api.toggleTodoDone(
        todoId,
        Silverfin.currentCompanyId || getters.activeCompanyId
      )
      commit(mutationTypes.SET_TODO_DONE, {
        todo: getters.allTodos[todoId],
        done: response.done,
        doneAt: response.doneAt,
        doneByName: response.doneByName,
      })
      dispatch('fetchNotifications')
      window.eventHub.$emit('resetNotificationCount')
    },

    // can pass only one param to an action so passing an array and destructuring it in place
    // - https://github.com/vuejs/vuex/issues/366
    setRemarkSticky({ commit, getters }, [id, shouldBecomeSticky]) {
      api.setRemarkSticky(id, shouldBecomeSticky).then((response) => {
        commit(mutationTypes.SET_REMARK_STICKY, {
          remark: getters.remarkById(id),
          sticky: response.remark.sticky,
        })
      })
    },

    async toggleRemarkFollow({ commit, getters }, id) {
      const response = await api.toggleFollow(id)
      commit(mutationTypes.SET_REMARK_FOLLOWER_IDS, {
        remark: getters.remarkById(id),
        followerIds: response.followerIds,
      })
    },

    async updateRemark({ rootState }, [id, changedAttrs]) {
      const { remark } = await api.update(
        id,
        changedAttrs,
        Silverfin.currentCompanyId || rootState.notifications.activeCompanyId
      )
      window.eventHub.$emit('refreshCommunicationData', {
        remark,
        action: REMARK_ACTIONS.EDITED,
      })

      window.eventHub.$emit('scrollToElement', {
        elementType: 'remark',
        elementId: id,
      })
    },

    async deleteRemarkAttachment({ getters, dispatch }, { id, attachmentId }) {
      const remark = getters.remarkById(id)
      await api.update(id, {
        fileAttrs: remark.attachmentIds
          .filter((id) => id !== attachmentId)
          .map((id) => ({
            id,
          })),
      })
      dispatch('fetchCommunication')
      window.eventHub.$emit('scrollToElement', {
        elementType: 'remark',
        elementId: id,
      })
    },
  },
}

export default Remarks
